import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_READ } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import Combobox from '../Helper/Combobox';
import ControlledGrid from '../Helper/ControlledGrid';
import Grid from '../Helper/Grid';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import Alerte from './Alerte';
import Document from './Document';
import MotCle from './MotCle';
import Thematique from './Thematique';
import UniteProjet from './UniteProjet';
import TypeDocument from './TypeDocument';


import AdvancedCombobox from '../Helper/AdvancedCombobox';


class Observation extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Observation";
  }

  constructor(props) {
    super(props);


    this.handleUniteChange = this.handleUniteChange.bind(this);
  }
  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}

  			<Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de l'observation.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idObservation" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idObservation")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="titre">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Titre</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("titre")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>



          {/* Frequence OneToMany */}
          <FormGroup controlId="idFrequence">
            <Col componentClass={ControlLabel} sm={2}>Fréquence</Col>
            <Col sm={6}><Combobox url={REST_API_URL + "frequences/"} optionValueKey="idFrequence" optionLabelKey="titre" onChange={this.onFrequenceSelect.bind(this)}
              placeholder="Choisir une fréquence" default={this.getObjectProperty("idFrequence")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Unite OneToMany */}
          {/*
          <FormGroup controlId="idUniteProjet">
            <Col componentClass={ControlLabel} sm={2}>Unité</Col>
            <Col sm={6}><Combobox url={REST_API_URL + "uniteprojets/"} optionValueKey="idUniteProjet" optionLabelKey="libelle" onChange={this.onUniteSelect.bind(this)}
              placeholder="Choisir une unité" default={this.getObjectProperty("idUniteProjet")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>
 */}

          {/* UniteProjet ManyToMany */}
          <PermissionCheck component={UniteProjet.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="idUniteProjet">
              <Col componentClass={ControlLabel} sm={2}>Unité</Col>
              <Col sm={2}><AdvancedCombobox path="uniteprojets" objectPath={this.getObjectPath() + "uniteprojets"} objectClass={UniteProjet} url={REST_API_URL + "uniteprojets/"}
                optionValueKey="idUniteProjet" optionLabelKey="libelle" default={this.getObjectProperty("idUniteProjet")} onChange={this.handleUniteChange} disabled={this.getReadOnly()}
                enableSearch={true} /></Col>
            </FormGroup>
          </PermissionCheck>

          {/* Thematique ManyToMany */}
          <PermissionCheck component={Thematique.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="thematiques">
            <Col componentClass={ControlLabel} sm={2}>Thématiques</Col>
            <Col sm={6}>
              <ControlledGrid ref="thematiquesGrid" path="thematiques" objectPath={"observations_thematiques/" + this.state.object.idObservation + "/thematiques"}
              objectClass={Thematique} mode={this.state.mode} cbxUrl={REST_API_URL + "observations_thematiques/" + this.state.object.idObservation + "/thematiques/inverse/"}
              optionValueKey="idThematique" optionLabelKey="libelle" />
            </Col>
            </FormGroup>
          </PermissionCheck>

          {/* MotCle ManyToMany */}
          <PermissionCheck component={MotCle.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="motCles">
            <Col componentClass={ControlLabel} sm={2}>Mots clé</Col>
            <Col sm={6}>
              <ControlledGrid ref="motclesGrid" path="motcles" objectPath={"observations_motcles/" + this.state.object.idObservation + "/motcles"} objectClass={MotCle}
              mode={this.state.mode} cbxUrl={REST_API_URL + "observations_motcles/" + this.state.object.idObservation + "/motcles/inverse/"} optionValueKey="idMotCle"
              optionLabelKey="libelle" />
            </Col>
            </FormGroup>
          </PermissionCheck>

          {/* Alerte OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Alerte.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Alertes" path="alertes" objectPath={"observations/" + this.getObjectProperty("idObservation") + "/alertes"} objectClass={Alerte}
              hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Document OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Document.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Documents" path="documents" objectPath={"observations/" + this.getObjectProperty("idObservation") + "/documents"} objectClass={Document}
              hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup> : ""
          }
  			</Form>

      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idObservation";
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();
    let observationObj = cloneObject(this.state.object);

    console.log("send obs");
    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
      if(this.refs.thematiquesGrid !== undefined) observationObj.thematiques = this.refs.thematiquesGrid.getArrayToSave();
      if(this.refs.motclesGrid !== undefined) observationObj.motCles = this.refs.motclesGrid.getArrayToSave();
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(observationObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.saveGrids();
        this.setState({
          status: {
            type: 'success',
            message: 'Observation sauvegardée.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Observation créée.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/observations/" + newObj[this.getIdField()] + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * saveGrids
  * Saves the ManyToMany components
  **/
  saveGrids() {
    if(this.refs.thematiquesGrid !== undefined) this.refs.thematiquesGrid.saveAll();
    if(this.refs.motclesGrid !== undefined) this.refs.motclesGrid.saveAll();
  }

  /**
  * onFrequenceSelect
  * Modify the state idFrequence property from idFrequence Combobox change
  **/
  onFrequenceSelect(frequence) {
    let objState = this.state;
    objState.object["idFrequence"] = frequence.idFrequence;
    this.setState(objState);
  }

  /**
  * onUniteSelect
  * Modify the state idUniteProjet property from idUniteProjet Combobox change
  **/
  onUniteSelect(unite) {
    let objState = this.state;
    objState.object["idUniteProjet"] = unite.idUniteProjet;
    this.setState(objState);
  }


  handleUniteChange(uniteProjet) {
    let objState = this.state;
    objState.object["idUniteProjet"] = (uniteProjet) ? uniteProjet.idUniteProjet : null;
    this.setState(objState);
  }

  /**
  * handleTypeDocumentChange
  * Handle TypeDocument onChange event
  **/

}

export default Observation;



// WEBPACK FOOTER //
// ./src/views/Entity/Observation.js